import { createReportProblem } from '../api/zendesk'
import type { Resolvers } from '../generated/server/resolvers'

const ZendeskResolver: Resolvers = {
  Mutation: {
    createReportProblem: async (_, params) => await createReportProblem(params.input),
  },
}

export default ZendeskResolver
